import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
const StyledDynamicPinningTableLayout = styled('table', {
    borderCollapse: 'separate',
    borderSpacing: 0,
    whiteSpace: 'nowrap',
    width: '100%',
});
export const DynamicPinningTableLayout = ({ children, }) => {
    return (_jsx(StyledDynamicPinningTableLayout, { children: children }));
};
